module.exports = __webpack_public_path__ + "media/images/cards/discover-009b15c8e84345d769e5b22700f300bb.png";